import React from 'react';
import _ from "lodash";

import withWidth from "@material-ui/core/withWidth/withWidth";

import useStyles from './styles';
import ChartLegend from '../../../../../../components/Charts/Legend';
import PerformanceFixedColumnsBarChart from '../../../../../../components/Charts/PerformanceFixedColumnBarChart';
import WarningTooltip from "../../../../../../components/WarningTooltip";
import clsx from "clsx";
import ChartSectionBordered from "../../../../components_v2/ChartSectionBordered/ChartSectionBordered";
import {useHistoricalData} from "../../../../hooks/useHistoricalData";
import {getPortfolioChartName} from "../../../../utils";


const _performanceBarChartPropsAreEquals = (prevProps, nextProps) => {
  return prevProps.chartData.timestamp === nextProps.chartData.timestamp
}

const _PerformanceBarChart = React.memo(({chartData, classes}) => {
  return (
    <div className={classes.chartContainer}>
      <PerformanceFixedColumnsBarChart categories={chartData.years} data={chartData.data}/>
      <ChartLegend legendItems={chartData.data} />
    </div>
  )
}, _performanceBarChartPropsAreEquals)


const getYearsToShowAggregated = (data) => {
  // return years with count of depots with data
  let valid_years = {};
  data.forEach(portfolio => {
    if(portfolio.pk != 0) {
      portfolio.year_performance.forEach(year => {
        if(year.performance_eur !== 0){
          let val = _.get(valid_years, year.year, 0)
          _.set(valid_years, `${year.year}`, val+1)
        }
      })
    }
  })

  return valid_years
}

export const getPerformanceBarChartData = (portfolios, aggregatedPortfolioName) => {
  let data = [];
  let yearsMap = {};
  let aggregated_years = getYearsToShowAggregated(portfolios)

  portfolios.forEach(portfolio => {
    const portfolio_data = [];
    const portfolio_data_exist = portfolio.year_performance.some(item => item.performance != 0);

    if (portfolio_data_exist) {
      portfolio.year_performance.forEach(item => {
        let showBar = portfolio.pk != 0 || aggregated_years[item.year] > 1;

        let yPlotItem = item.performance ? parseFloat((item.performance * 100).toFixed(2)) : null
        portfolio_data.push({
          y: showBar ? yPlotItem : null,
          inEur: showBar ? parseFloat((item.performance_eur).toFixed(2)) : null,
        });
        yearsMap[item.year] = true;

      });
      if (portfolio_data.some(p => p.y !== null)) { //in case portfolio has no points on chart => skip it
        data.push({
          portfolio: {
            name: getPortfolioChartName(portfolio, aggregatedPortfolioName),
            data: portfolio_data,
            color: portfolio.color
          }
        });
      }
    }
  });
  return [data, yearsMap]
}

export default withWidth()((props) => {
  const classes = useStyles();

  const {
    width,
    onExpanded,
    expanded,
    customerId,
    startDate,
    endDate,
    dataProvider,
    portfolios,
    withHistorical,
    aggregatedPortfolioName,
    investmentStrategyId,
    useSharedDataOnly,
  } = props;

  const historicalData = useHistoricalData(customerId, portfolios, startDate, endDate, withHistorical, dataProvider, useSharedDataOnly, investmentStrategyId);

  const [
    dashboardData,
    dashboardDataLoading,
    dashboardDataLoadingError,
    timestamp
  ] = [
    historicalData.data,
    historicalData.loading,
    historicalData.errors,
    historicalData.updatedAt
  ]

  const [reloadTrigger, setReloadTrigger] = React.useState(false);
  const [chartData, setChartData] = React.useState({
    data: [],
    years: [],
    error: false
  });


  React.useEffect(() => {
    setReloadTrigger(true);
    updateChartData();
    setTimeout(() => {
      setReloadTrigger(false);
    }, 100);
  }, [dashboardData, timestamp]);

  const updateChartData = () => {
    if (_.isArray(dashboardData && dashboardData.portfolios)){

      let [data, yearsMap] = getPerformanceBarChartData(dashboardData.portfolios, aggregatedPortfolioName);

      setChartData({
        error: false,
        years: Object.keys(yearsMap).sort(),
        data,
        timestamp: new Date().getTime()
      });
    } else {
      setChartData({
        error: true,
        data: [],
        years: []
      })
    }
  };

  return (
    <ChartSectionBordered
      title={(
        <>
          <b>Jährliche Wertentwicklung der Depots der letzten 5 Jahre in %</b>
          <WarningTooltip
            title={"Berechnet nach geldgewichteter Methode bzw. nach Modified Dietz."}
            icon={<i className={clsx("far fa-info-circle", classes.chartSectionHeaderInfoIcon)}/>}
            width={600}
            interactive
          />
        </>
      )}
      content={dashboardData && (
        <_PerformanceBarChart chartData={chartData} classes={classes}/>
      )}
      loading={dashboardDataLoading || reloadTrigger}
      error={dashboardDataLoadingError || chartData.error}
      displayError={true}
      minHeight={['xs', 'sm', 'md'].includes(width) ? 520 : 486}
      empty={chartData.years.length === 0}
      expanded={expanded}
      onExpanded={onExpanded}
    />
  );
});